import * as React from 'react';
import CloseButton from '../close-button/CloseButton';
import { GridWrapper } from '../grid/Grid';
import ReportNotificationModal from './components/report-notification-modal/ReportNotificationModal';
import ReadReportContent from './components/read-report-content/ReadReportContent';
import { Label, Heading1, Paragraph } from '../elements/index';
import { State } from '../../models/Enums';
import ReadReportMenu from './components/read-report-menu/ReadReportMenu';
import classNames from 'classnames';
import { observer } from 'mobx-react';
import logo from '../../../public/media/svg/tfo-logo.svg';
import classnames from 'classnames';
import { useStore } from '../../hooks';
import { useHistory } from 'react-router-dom';
import { Loader } from '../..';
export const Report = observer(({ reportStore, formatDate, i18n, formatTime, InfoSection, ReportSummary, closeReport, getFilesMetaData, getFile, }) => {
    var _a, _b;
    const clientViewStore = useStore().clientViewStore;
    const history = useHistory();
    const openModal = (id) => {
        reportStore.infoModalData = {
            header: i18n(id + '.header'),
            body: i18n(id + '.body')
        };
        reportStore.showInfoModal = true;
    };
    const classesOverlayLayer = classnames('ClientContainerOverlay', { 'ClientContainerOverlay--initialLoad': reportStore.loading }, { 'ClientContainerOverlay--loading': reportStore.loading }, { 'ClientContainerOverlay--animateIn': reportStore.loading });
    const headerStyle = classNames('ReadReportHeader', {
        'ReadReportHeader--narrow': reportStore.order.state === State.Deleted
    });
    const ShowIDDText = () => {
        if (reportStore.isIDD && !reportStore.order.reportSummary) {
            return (React.createElement(Paragraph, { className: 'ReadReportHeader__Paragraph', style: { color: 'grey' } }, i18n('readreport.header.informationtext.discrepancies')));
        }
        return null;
    };
    return (React.createElement(React.Fragment, null, reportStore.initialDataLoaded ? (React.createElement(React.Fragment, null,
        React.createElement("div", { className: classesOverlayLayer, style: { position: 'absolute', left: 0 } },
            reportStore.order && (React.createElement("div", { className: 'ReadReport' },
                React.createElement("div", { className: headerStyle },
                    React.createElement("img", { src: logo, className: "ReadReport__Logo", alt: "" }),
                    React.createElement(GridWrapper, null,
                        React.createElement("div", { className: 'ReadReportHeader__Heading' },
                            ReportSummary && (React.createElement(Label, null,
                                " ",
                                reportStore.reportPackageName,
                                " ")),
                            (reportStore.order.isConsideredArchived === false && reportStore.order.state !== State.Deleted) && (React.createElement(Heading1, { className: 'ReadReportHeader__Heading1' }, `${(_a = reportStore.order.candidate) === null || _a === void 0 ? void 0 : _a.firstName} ${(_b = reportStore.order.candidate) === null || _b === void 0 ? void 0 : _b.lastName}`)),
                            React.createElement(Paragraph, { className: 'ReadReportHeader__Paragraph' }, i18n('readreport.header.disclaimer')),
                            React.createElement(ShowIDDText, null))),
                    (reportStore.order.isConsideredArchived === false && reportStore.order.state !== State.Deleted) && (React.createElement(ReadReportMenu, { store: reportStore, isCup: Boolean(ReportSummary) })),
                    React.createElement(CloseButton, { className: 'ReadReport__Close', onClick: closeReport || (() => history.goBack()) })),
                React.createElement(GridWrapper, null,
                    React.createElement(ReadReportContent, Object.assign({}, {
                        formatDate,
                        formatTime,
                        i18n,
                        reportStore,
                        InfoSection,
                        ReportSummary,
                        getFilesMetaData,
                        getFile,
                    }, { onInfoButtonClick: openModal }))))),
            reportStore.showInfoModal && (React.createElement(ReportNotificationModal, { header: reportStore.infoModalData.header, body: reportStore.infoModalData.body, onCloseClick: () => (reportStore.showInfoModal = false) }))))) : (React.createElement(Loader, null))));
});
